import type React from 'react';

interface MetricCardProps {
  icon: React.ElementType;
  label: string;
  value: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  icon: Icon,
  label,
  value,
}) => (
  <div className="flex flex-col gap-2 rounded-[14px] border border-gc-line bg-white p-4">
    <Icon className="h-5 w-5 text-gc-blue" />
    <span className="text-[22px] font-bold text-gc-ink">{value}</span>
    <span className="text-[13px] text-gc-muted">{label}</span>
  </div>
);
